export function guadRange(value: number, min: number, max: number) {
  return Math.max(Math.min(value, max), min);
}

export function swap<T>(arr: T[], oldIndex: number, newIndex: number) {
  const newArray = [...arr];
  const temp = arr[newIndex];
  newArray[newIndex] = newArray[oldIndex];
  newArray[oldIndex] = temp;
  return newArray;
}

export function move<T>(arr: T[], oldIndex: number, newIndex: number) {
  const newArray = [...arr];
  newArray.splice(newIndex, 0, newArray.splice(oldIndex, 1)[0]);
  return newArray;
}

export function moveItems<T>(arr: T[], oldIndex: number, newIndex: number, count: number) {
  const newArray = [...arr];
  newArray.splice(newIndex, 0, ...newArray.splice(oldIndex, count));
  return newArray;
}

export function replaceAtIndex<T>(arr: T[], index: number, newItem: T) {
  return arr.map((item, i) => (index === i ? newItem : item));
}

export function roundDecimal(n: number, round: number): number {
  return Math.round(n * Math.pow(10, round)) / Math.pow(10, round);
}
